<template>
<el-collapse-item :name="'a-'+item.id">
    <template slot="title">
      <div class="row pad yo-text-bold">
        <div class="col s1 mm yo-align-right yo-text-n yo-valign-text-center" style="height:48px;">{{(index+1)}}</div>
        <div class="col s11 m11m yo-valign-text-center" style="height:48px;" v-if="item.id!=current">{{ item.titolo | maxlenght(parseInt($teras.app.width/18))}}</div>
        <div class="col s11 m11m yo-valign-text-center" style="height:48px;" v-if="item.id==current">{{ item.titolo | maxlenght(parseInt($teras.app.width/19-8))}}</div>
        <!--
        <div class="col s2 yo-align-left">{{item.id}}</div>
        <div class="col s1 red yo-text-bold yo-align-right" v-if="item.nr_numero>10" style="">{{item.nr_numero}}&#160;&#160;<i class="material-icons" style="float:right;margin-right:12px;line-height:48px;">error</i></div>
        <div class="col s1 tree_poppy yo-text-bold yo-align-right" v-if="item.nr_numero>0 && item.nr_numero<11" style="">{{item.nr_numero}}&#160;&#160;<i class="material-icons" style="float:right;margin-right:12px;line-height:48px;">warning</i></div>
        <div class="col s1 grees yo-text-bold yo-align-right" v-if="item.nr_numero==0" style=""><i class="material-icons" style="float:right;margin-right:12px;line-height:48px;">done</i></div>
         -->
      </div>
    </template>

    <div class="row pad" style="margin-top:16px;">

      <div class="col s7 m3 yo-align-right">IDENTIFICATION NUMBER</div>
      <div class="col s5 m9 yo-text-bold">{{item.id}}</div>

      <div v-if="item.codaffissione!=''" class="col s7 m3 yo-align-right">CODEASSIGN</div>
      <div v-if="item.codaffissione!=''" class="col s5 m9 yo-text-bold">{{item.codaffissione}}</div>

      <div class="col s7 m3 yo-align-right">CREATION DATE</div>
      <div class="col s5 m9 yo-text-bold">{{item.iniziatoil | data('MMMM Do YYYY, hh:mm')}} </div>

      <div class="col s7 m3 yo-align-right">LAST MODIFICATION DATE</div>
      <div class="col s5 m9 yo-text-bold">{{item.modificatoil | data('MMMM Do YYYY, hh:mm')}} </div>

      <div class="col s7 m3 yo-align-right clear">TOPIC</div>
      <div class="col s5 m9 yo-text-bold">{{item.topic | items($evento._topic,'nome')}}</div>

      <div class="col s7 m3 yo-align-right clear">KEYWORDS</div>
      <div class="col s5 m9 yo-text-bold">{{item.parolechiave}}</div>

      <div class="col s7 m3 clear yo-align-right">ORAL PRESENTATION</div>
      <div class="col s5 m9 yo-text-bold">{{item.oral | yesno}}</div>

      <div class="col s7 m3 clear yo-align-right">BEST POSTER AWARD</div>
      <div class="col s5 m9 yo-text-bold">{{item.bestposterawards | yesno}}</div>

      <div class="col s7 m3 clear yo-align-right">FLASH POSTER PRESENTATION</div>
      <div class="col s5 m9 yo-text-bold">{{item.flashposterpresentation | yesno}}</div>

      <div class="col s7 m3 clear yo-align-right">CHAIRED POSTER SESSION</div>
      <div class="col s5 m9 yo-text-bold">{{item.chairedposterpresentation | yesno}}</div>

      <div class="col s7 m3 clear yo-align-right">PAPER POSTER</div>
      <div class="col s5 m9 yo-text-bold">{{item.paperposter | yesno}}</div>

      <div class="col s7 m3 clear yo-align-right">PRESENTING AUTHOR</div>
      <div class="col s5 m9 yo-text-bold">{{item.presentingautore}}</div>

      <div class="col s7 m3 clear yo-align-right">AUTHORS</div>
      <div class="col s5 m9 yo-text-bold">{{item.autori}}</div>

      <!--
      <div class="col s7 m3 yo-align-right">AUTHOR NUMBERS</div>
      <div class="col s5 m9 yo-text-bold">{{item.autoricount}}</div>
      -->

      <div class="col s7 m3 clear yo-align-right">WORDS NUMBER</div>
      <div class="col s5 m9 yo-text-bold">{{item.wordcount}}</div>



   </div>

  <div class="row" style="margin-top:12px;border-top:0px dashed #5288C6;padding-top:6px;">
    <div class="col s12 m3 offset-m3 yo-text-bold">
    
     <el-dropdown @command="handleCommand" style="width:100%;" placement="top-end"  v-if="item.step==0 || item.step==22">
      <el-button type="primary" size="small" style="width:100%;">
        ACTION LIST<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown" trigger="click">
        <el-dropdown-item command="profile">ADD / EDIT ABSTRACT</el-dropdown-item> 
        <el-dropdown-item command="autore">ADD / EDIT AUTHORS</el-dropdown-item>
        <el-dropdown-item command="testo">ADD / EDIT TEXT</el-dropdown-item>
        <el-dropdown-item command="preview" v-if="item.preview=='' && item.wordcount>0 && item.autoricount>0">MAKE PREVIEW</el-dropdown-item>
        
        <a v-if="item.preview!='' && item.wordcount>0 && item.autoricount>0" :href="item.preview" target="_blank" style="color:#353535;"><el-dropdown-item >SHOW PREVIEW</el-dropdown-item></a>
        <el-dropdown-item command="send" v-if="item.preview!='' && item.wordcount>0 && item.autoricount>0 && item.step==0 && ($moment($evento.profile.row.deadline_invio).diff($moment(),'minutes')>0)">SUBMIT</el-dropdown-item>
        <el-dropdown-item command="resend" v-if="item.preview!='' && item.wordcount>0 && item.autoricount>0 && ($moment($evento.profile.row.deadline_invio).diff($moment(),'minutes')<0) && $moment($evento.profile.row.deadlinemodifica).diff($moment(),'minutes')>0">SUBMIT AFTER REVIEW</el-dropdown-item>
        <el-dropdown-item divided command="rowDel">DELETE</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    
     <el-dropdown @command="handleCommand" style="width:100%;" placement="top-end"  v-if="item.step==10">
      <el-button type="primary" size="small" style="width:100%;">
        ACTION LIST<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <a v-if="item.preview!='' && item.wordcount>0 && item.autoricount>0" :href="item.preview" target="_blank"><el-dropdown-item >SHOW PREVIEW</el-dropdown-item></a>
        <el-dropdown-item divided command="edit" v-if="$moment($evento.profile.row.deadline_invio).diff($moment(),'minutes')>0">ENABLE EDITING</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    
     <el-dropdown @command="handleCommand" style="width:100%;" placement="top-end"  v-if="item.step==20 || item.step==30">
      <el-button type="primary" size="small" style="width:100%;">
        ACTION LIST <i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <a v-if="item.preview!='' && item.wordcount>0 && item.autoricount>0" :href="item.preview" target="_blank"><el-dropdown-item >SHOW PREVIEW</el-dropdown-item></a>
        <el-dropdown-item divided command="edit" v-if="$moment($evento.profile.row.deadlinemodifica).diff($moment(),'minutes')>0">ENABLE EDITING</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>



    
     <el-dropdown @command="handleCommand" style="width:100%;" placement="top-end"  v-if="item.step==11 || item.step==21 || item.step==31">
      <el-button type="primary" size="small" style="width:100%;">
        ACTION LIST<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        
        <el-dropdown-item  command="confirm" v-if="item.step!=31 && !isafter && $moment($evento.profile.row.deadlinescritto).diff($moment(),'minutes')>0">CONFIRM ABSTRACT</el-dropdown-item>
        <el-dropdown-item  command="edit" v-if="item.step!=31 && !isafter && $moment($evento.profile.row.deadlinescritto).diff($moment(),'minutes')>0">ENABLE EDITING</el-dropdown-item>
        <a v-if="item.preview!='' && item.wordcount>0 && item.autoricount>0" :href="item.preview" target="_blank"><el-dropdown-item >SHOW PREVIEW</el-dropdown-item></a>


        <el-dropdown-item v-if="item.step=31" command="emailprimoautore">ADD / EDIT EMAIL FIRST AUTHOR</el-dropdown-item>

        


        <el-dropdown-item divided command="rowDel">DELETE</el-dropdown-item>
      
      </el-dropdown-menu>
    </el-dropdown>


     <el-dropdown @command="handleCommand" style="width:100%;" placement="top-end"  v-if="item.step==99">
      <el-button type="primary" size="small" style="width:100%;">
        ACTION LIST<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">

        <a v-if="item.preview!='' && item.wordcount>0 && item.autoricount>0" :href="item.preview" target="_blank"><el-dropdown-item >SHOW PREVIEW</el-dropdown-item></a>


        
        <!-- Non usato nell'edizione 2024 -->
        <blockquote v-if="item.etype==2 && $moment($evento.profile.row.deadline_efile_fine).diff($moment(),'minutes')>0">
        <el-dropdown-item divided command="eoral" >ADD / REPLACE ORAL PRESENTATION</el-dropdown-item> 
        <a v-if="eoralURL!=''" :href="eoralURL" target="_blank" style="color:#353535;"><el-dropdown-item >SHOW ORAL PRESENTATION</el-dropdown-item></a> 
        </blockquote>

        <blockquote v-if="item.etype==4 && $moment($evento.profile.row.deadline_efile_fine).diff($moment(),'minutes')>0">
        <el-dropdown-item divided command="etalk" >ADD / REPLACE FLASH POSTER</el-dropdown-item> 
        <a v-if="etalkURL!=''" :href="etalkURL" target="_blank" style="color:#353535;"><el-dropdown-item >SHOW FLASH POSTER</el-dropdown-item></a>
        </blockquote>

        <blockquote v-if="(item.etype==1 || item.etype==5) && $moment($evento.profile.row.deadline_efile_fine).diff($moment(),'minutes')>0">
        <el-dropdown-item divided command="eposter" >ADD / REPLACE E-POSTER </el-dropdown-item> 
        <a v-if="eposterURL!=''" :href="eposterURL" target="_blank" style="color:#353535;"><el-dropdown-item >SHOW E-POSTER </el-dropdown-item></a> 
        </blockquote>
        
        
      </el-dropdown-menu>
    </el-dropdown>




    
     <el-dropdown @command="handleCommand" style="width:100%;" placement="top-end"  v-if="item.step==90">
      <el-button type="primary" size="small" style="width:100%;">
        ACTION LIST<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <a v-if="item.preview!='' && item.wordcount>0 && item.autoricount>0" :href="item.preview" target="_blank"><el-dropdown-item >SHOW PREVIEW</el-dropdown-item></a>
        <!-- <el-dropdown-item divided command="edit" v-if="$moment($evento.profile.row.deadlinescritto).diff($moment(),'minutes')>0">ENABLE EDITING</el-dropdown-item> -->
      </el-dropdown-menu>
    </el-dropdown>



    </div>



  <div class="col s12 m2 offset-m3 yo-text-bold" v-if="$teras.check.admin">
  <el-dropdown @command="handleCommand" style="width:100%;" placement="top-end" >
      <el-button type="danger" size="small" style="width:100%;">
        ACTION ADMIN<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown" trigger="click">
        <el-dropdown-item command="profile">ADD / EDIT ABSTRACT</el-dropdown-item> 
        <el-dropdown-item command="autore">ADD / EDIT AUTHORS</el-dropdown-item>
        <el-dropdown-item command="testo">ADD / EDIT TEXT</el-dropdown-item>
        <el-dropdown-item command="emailprimoautore">ADD / EDIT EMAIL FIRST AUTHOR</el-dropdown-item>
        <el-dropdown-item divided command="preview" >MAKE PREVIEW</el-dropdown-item>
        <a v-if="item.preview!='' && item.wordcount>0 && item.autoricount>0" :href="item.preview" target="_blank" style="color:#353535;"><el-dropdown-item >SHOW PREVIEW</el-dropdown-item></a>

        <!-- Non usato nell'edizione 2024 --> 
        <blockquote v-if="item.etype==2 ">
        <el-dropdown-item divided command="eoral" >ADD / REPLACE ORAL PRESENTATION</el-dropdown-item> 
        <a v-if="eoralURL!=''" :href="eoralURL" target="_blank" style="color:#353535;"><el-dropdown-item >SHOW ORAL PRESENTATION</el-dropdown-item></a> 
        </blockquote>

        <blockquote v-if="item.etype==4">
        <el-dropdown-item divided command="etalk" >ADD / REPLACE FLASH TALK PRESENTATION</el-dropdown-item> 
        <a v-if="etalkURL!=''" :href="etalkURL" target="_blank" style="color:#353535;"><el-dropdown-item >SHOW FLASH TALK PRESENTATION</el-dropdown-item></a>
        </blockquote>

        <blockquote v-if="(item.etype==1 || item.etype==5)">
        <el-dropdown-item divided command="eposter" >ADD / REPLACE E-POSTER </el-dropdown-item> 
        <a v-if="eposterURL!=''" :href="eposterURL" target="_blank" style="color:#353535;"><el-dropdown-item >SHOW E-POSTER </el-dropdown-item></a> 
        </blockquote>
        
        

        <el-dropdown-item divided command="rowDel">DELETE</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    </div>

</div>



</el-collapse-item>
</template>


<script>
import emailSubmission from './Email-submission.vue'
import emailReopen from './Email-reopen.vue'
import emailConfirm from './Email-confirm.vue'
import emailDelete from './Email-delete.vue'


export default {
  name: 'item-elenco',
  data() {
    return {
      loading: {}
    }
  },
  created () {
    this.$teras.pageHeader = 80
  },
  mounted () {
    this.$emit('scrollTop', 0)
  },
  props: {
    index: Number,
    item: Object,
    current: String,
    isafter: Boolean
  },
  methods: {
    handleCommand(command) {
      switch (command){
        case 'profile':
        case 'autore':
        case 'testo':
        case 'message':
        case 'eoral':
        case 'etalk':
        case 'eposter':
        case 'emailprimoautore':
        this.loadScheda(command)
        break;

        case 'preview':
        this.preview()
        break;

        case 'send':
        this.send()
        break;

        case 'resend':
        this.resend()
        break;

        case 'confirm':
        this.confirm()
        break;

        case 'edit':
        this.edit()
        break;

        case 'rowDel':
        this.rowDel()
        break;

      }

    },
    rowDel () {
      let popuptesto='Error for step of abstract ('+this.item.step+')'
      switch (this.item.step){
        case 11:
        case 21:
        popuptesto = 'ATTENTION: Are you sure you want to delete your abstract? Your work will be cancelled and the corresponding slot will be released.Click YES if you want to proceed.'
        break;

        default:
        popuptesto = 'The Abstract "'+this.item.titolo+'" will be deleted, are you sure?'
        break;
      }
      this.$confirm(popuptesto, 'Please read carefully', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        this.loading = this.$loading({lock: true, text: 'Loading in progress, do not reload the page.....just wait!', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
        this.$axios.query('doQuery',`UPDATE abstract SET step=-1 WHERE id=←id`,{id: this.item.id}).then(async (response) => {
          this.$contatto.getAbstract()

          var html = this.$teras.renderVue(emailDelete,{contatto:this.$contatto.profile.row, evento:this.$evento.profile.row, abstract: this.item})
          this.$axios.email({from:this.$evento.profile.row.emailreferee,oggetto:this.$contatto.profile.row.cognome+' '+this.$contatto.profile.row.nome+' delete abstract for: '+this.$evento.profile.row.nome,to:'info@terasmm.it,'+this.$evento.profile.row.emailreferee,body:html})
          this.$axios.email({from:this.$evento.profile.row.emailreferee,oggetto:'Your abstract has been deleted',to:this.$contatto.profile.row.email,body:html}).then((data) => {
            this.loading.close()
            this.$alert('Your abstract has been deleted correctly', this.$teras.alert_success)
          }).catch((error) => {
            this.loading.close()
            this.$alert(error, this.$teras.alert_error)
          })


          
        })
      }).catch(() => {
        this.$message({
            type: 'info',
            message: 'Operation canceled'
        })         
      })
      
    },
   async loadScheda(scheda) {
      await this.$abstract.profile.load(this.item.id)
        console.log(this.item.id+' » '+this.item.bestposterawards+' » '+this.$abstract.profile.row.bestposterawards)

        console.log(this.$abstract.profile.row)
        this.$router.push('/abstract-'+scheda)
      
    },

    preview() {
      this.$confirm('When submitting your abstract, you hereby agree that your abstract will be published in the Symposium Abstract Book. An electronic version of the poster (pdf format) provided by the presenting authors who have already registered for the Symposium will be made available online on the ESPHM platform and on e-poster stations during the Symposium. Proceed?', 'Disclaimer', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(async () => {
        this.loading = this.$loading({lock: true, text: 'Loading in progress, do not reload the page.....just wait!', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
      
        //this.$axios.get('https://esphm.mzevents.it/index/creapdf',{absid: this.item.id, template: this.$evento.profile.row.templatepreview, apri: false}).then((response) => {
        this.$axios.get('https://esphm.mzevents.it/index/creapdf/absid/'+this.item.id+'/template/'+this.$evento.profile.row.templatepreview+'/apri/false',{}).then((response) => {
          console.log(response.data)
          if(response.data.data.esito){
            this.$axios.query('doQuery',`UPDATE abstract SET preview=→preview, previewil=→previewil WHERE id=←id`,{id: this.item.id, preview: response.data.data.message, previewil: this.$moment().format('YYYY-MM-DD HH:mm:00')}).then(async (response) => {
              this.$contatto.getAbstract()
              this.loading.close()
              this.$alert('Abstract preview created correctly, please click "Show Preview" to download the pdf', this.$teras.alert_success)
            })

          }else{
            this.loading.close()
            this.$message({type: 'info', message: response.data.data.error}) 
            
          }
        }).catch((error) => {
          this.loading.close()
          this.$message({type: 'info', message: error}) 
        })
        
      }).catch(() => {
        this.$message({
            type: 'info',
            message: 'Operation canceled'
        })         
      })

        
    },

    send() {
      this.$confirm('Are you sure you want to send the abstract?', 'Please read carefully', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(async () => {
        this.loading = this.$loading({lock: true, text: 'Loading in progress, do not reload the page.....just wait!', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })

        this.$axios.query('doQuery',`UPDATE abstract SET step=10, inviatoil=→inviatoil WHERE id=←id`,{id: this.item.id, inviatoil: this.$moment().format('YYYY-MM-DD HH:mm:00')}).then(async (response) => {
          this.$contatto.getAbstract()
          
          var html = this.$teras.renderVue(emailSubmission,{contatto:this.$contatto.profile.row, evento:this.$evento.profile.row, abstract: this.item})
          this.$axios.email({from:this.$evento.profile.row.emailreferee,oggetto:this.$contatto.profile.row.cognome+' '+this.$contatto.profile.row.nome+' send abstract for: '+this.$evento.profile.row.nome,to:'info@terasmm.it',body:html})
          this.$axios.email({from:this.$evento.profile.row.emailreferee,oggetto:'Your abstract has been processed',to:this.$contatto.profile.row.email,body:html}).then((data) => {
            this.loading.close()
            this.$alert('Your abstract has been sent correctly', this.$teras.alert_success)
          }).catch((error) => {
            this.loading.close()
            this.$alert(error, this.$teras.alert_error)
          })
          
          
        })  
        
      }).catch(() => {
        this.$message({
            type: 'info',
            message: 'Operation canceled'
        })         
      })

        
    },

    resend() {
      this.$confirm('Are you sure you want to send the abstract after reviewed it?', 'Please read carefully', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(async () => {
        this.loading = this.$loading({lock: true, text: 'Loading in progress, do not reload the page.....just wait!', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
        this.$axios.query('doQuery',`UPDATE abstract SET step=30, inviatoil=→inviatoil  WHERE id=←id`,{id: this.item.id, inviatoil: this.$moment().format('YYYY-MM-DD HH:mm:00')}).then(async (response) => {
          this.$contatto.getAbstract()
          var html = this.$teras.renderVue(emailSubmission,{contatto:this.$contatto.profile.row, evento:this.$evento.profile.row, abstract: this.item})
          this.$axios.email({from:this.$evento.profile.row.emailreferee,oggetto:this.$contatto.profile.row.cognome+' '+this.$contatto.profile.row.nome+' send after review abstract for: '+this.$evento.profile.row.nome,to:'abstracts@esphm2025.org,info@terasmm.it',body:html})
          //'abstract@esphm2020.org,mirko@terasmm.it'
          this.$axios.email({from:this.$evento.profile.row.emailreferee,oggetto:'Your abstract has been processed',to:this.$contatto.profile.row.email,body:html}).then((data) => {
            this.loading.close()
            this.$alert('Your abstract has been sent after review correctly', this.$teras.alert_success)
          }).catch((error) => {
            this.loading.close()
            this.$alert(error, this.$teras.alert_error)
          })
          
          
        })  
        
      }).catch(() => {
        this.$message({
            type: 'info',
            message: 'Operation canceled'
        })         
      })

    },

    confirm() {
      let popuptesto='Error for step of abstract ('+this.item.step+')'
      switch (this.item.step){
        case 11:
        case 21:
        popuptesto = 'ATTENTION: Please note that if you confirm your abstract as it is, you will not be able to change it or update it and it will keep the same slot as last year.Click YES if you want to proceed.'
        break;
      }
      this.$confirm(popuptesto, 'Please read carefully', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(async () => {
        this.loading = this.$loading({lock: true, text: 'Loading in progress, do not reload the page.....just wait!', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
        let step=31
        this.$axios.query('doQuery',`UPDATE abstract SET step=→step WHERE id=←id`,{id: this.item.id, step: step}).then(async (response) => {
          this.$contatto.getAbstract()
          this.loading.close()
        })  
        var html = this.$teras.renderVue(emailConfirm,{contatto:this.$contatto.profile.row, evento:this.$evento.profile.row, abstract: this.item})
        this.$axios.email({from:this.$evento.profile.row.emailreferee,oggetto:this.$contatto.profile.row.cognome+' '+this.$contatto.profile.row.nome+' confirmed his abstract for: '+this.$evento.profile.row.nome,to:'abstracts@esphm2025.org,info@terasmm.it',body:html})
        
      }).catch(() => {
        this.$message({
            type: 'info',
            message: 'Operation canceled'
        })         
      })

    },   
    
    edit() {
      let popuptesto='Error for step of abstract ('+this.item.step+')'
      switch (this.item.step){
        case 11:
        case 21:
        popuptesto = 'ATTENTION: please note that if you want to change or update your abstract, it will go back in draft mode and will be sent for a new review process; your work will be considered as newly submitted and it will  undergo the evaluation process. Click YES if you want to proceed.'
        break;

        case 90:
        popuptesto = 'RIFIUTATO......Are you sure you want to make in draft mode the abstract?'
        break;

        case 10:
        case 20:
        popuptesto = 'Are you sure you want to go back to DRAFT MODE?'
        break;
      }

      


      

      this.$confirm(popuptesto, 'Please read carefully', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(async () => {
        this.loading = this.$loading({lock: true, text: 'Loading in progress, do not reload the page.....just wait!', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
        let step=0
        /*switch (this.item.step){
          case '20':
          step = 22
          break;
        }*/
        this.$axios.query('doQuery',`UPDATE abstract SET step=→step, riapertoil=→riapertoil, inviatoil='0000-00-00 00:00:00'  WHERE id=←id`,{id: this.item.id, step: step,riapertoil: this.$moment().format('YYYY-MM-DD HH:mm:00')}).then(async (response) => {
          this.$contatto.getAbstract()
          this.loading.close()
        })  
        var html = this.$teras.renderVue(emailReopen,{contatto:this.$contatto.profile.row, evento:this.$evento.profile.row, abstract: this.item})
        this.$axios.email({from:this.$evento.profile.row.emailreferee,oggetto:this.$contatto.profile.row.cognome+' '+this.$contatto.profile.row.nome+' reopened his abstract for: '+this.$evento.profile.row.nome,to:'abstracts@esphm2025.org,info@terasmm.it',body:html})
        
      }).catch(() => {
        this.$message({
            type: 'info',
            message: 'Operation canceled'
        })         
      })
       
    } 
    
  },
  computed: {

    eoralURL:function() {
      let url =''
      if(this.item.eoral!=''){
      let file = JSON.parse(this.item.eoral)[0]
      url = 'https://esphm.mzevents.it/efile/'+this.$evento.profile.row.id+'/eoral/'+file.url
      }
      return url
    }
    ,etalkURL:function() {
      let url =''
      if(this.item.etalk!=''){
      let file = JSON.parse(this.item.etalk)[0]
      url = 'https://esphm.mzevents.it/efile/'+this.$evento.profile.row.id+'/etalk/'+file.url
      }
      return url
    }
    ,eposterURL:function() {
      let url =''
      if(this.item.eposter!=''){
      let file = JSON.parse(this.item.eposter)[0]
      url = 'https://esphm.mzevents.it/efile/'+this.$evento.profile.row.id+'/eposter/'+file.url
      }
      return url
    }
    ,isbefore:function(){
      return this.$moment().isBefore('2021-03-16 06:00:00','day')
    },

    actionTime:function(){
      let cosapossiamofareinbasealtempo=0
      if(this.$moment().isBefore(this.$evento.profile.row.deadline_invio)){
        //Possiamo inviare e modificare gli abstract
        cosapossiamofareinbasealtempo=10

      }else{
        if(this.$moment().isBefore(this.$evento.profile.row.deadline_revisione_inizio)){
          //Non possiamo fare nulla, siamo in attesa che i revisori verifichino gli abstract
          cosapossiamofareinbasealtempo=20
        }else{
          if(this.$moment().isBefore(this.$evento.profile.row.deadline_revisione_fine)){
            //Possiamo se richiesto modificare il nostro abstract come da richiesta dei revisori
            cosapossiamofareinbasealtempo=29
          }else{
            if(this.$moment().isBefore(this.$evento.profile.row.deadline_efile_inizio)){
              //Non possiamo fare nulla, siamo in attesa delle valutazioni finali dei revisori
              cosapossiamofareinbasealtempo=30
            }else{
              if(this.$moment().isBefore(this.$evento.profile.row.deadline_efile_fine)){
                //Possiamo se richiesto inviare gli efile di nostra competenza
                cosapossiamofareinbasealtempo=39
              }else{
                //In teoria non possiamo più fare nulla
                cosapossiamofareinbasealtempo=99
              }
            }

          }
        }
      }
      return cosapossiamofareinbasealtempo
    }
  }
}
</script>

<style>
.el-collapse-item__header{
  font-size:1.4rem;
}
.el-collapse-item__header.is-active{
  background:#ddd;
  font-size:1.5rem;
  font-weight:bold;
  
}
.el-collapse-item.is-active .el-collapse-item__wrap{
  background:#eee;
  
}
</style>
